import React, { createContext, useContext, useState } from 'react';

const GuestContext = createContext(null);

export function GuestProvider({ children }) {
  const [guestDetails, setGuestDetails] = useState(null);

  return (
    <GuestContext.Provider value={{ guestDetails, setGuestDetails }}>
      {children}
    </GuestContext.Provider>
  );
}

export function useGuest() {
  const ctx = useContext(GuestContext);
  if (!ctx) throw new Error('useGuest must be used within a GuestProvider');
  return ctx;
}
